import React, {useState} from 'react'
import {Checkbox} from 'react-materialize'

const ServiceItem = ({item, checkboxHandler, validTime}) => {
  const [quantity, setQuantity] = useState(0);

  return (
    <li className="collection-item">
      <span className="badge">
        <i className={`material-icons ${validTime ? 'orange-text' : 'grey-text'} quantity-btn`}
          onClick={() => {
            if (validTime) {
              quantity <= 0 ? setQuantity(0) : setQuantity(quantity-1);
              checkboxHandler(item.value, quantity-1);
              let checkbox = document.getElementById('checkbox-' + item.id);
              (quantity - 1) > 0 ? checkbox.checked = true : checkbox.checked = false;
            }
          }}>remove_circle</i>
          {quantity}
        <i className={`material-icons ${validTime ? 'orange-text' : 'grey-text'} quantity-btn`} 
          onClick={() => {
            if (validTime) {
              setQuantity(quantity+1);
              checkboxHandler(item.value, quantity+1)
              let checkbox = document.getElementById('checkbox-' + item.id);
              (quantity + 1) > 0 ? checkbox.checked = true : checkbox.checked = false;
            }
        }}>add_circle</i>
      </span>
      <Checkbox 
        value={item.value} 
        label={item.label}
        disabled={validTime ? false : true}
        id={`checkbox-${item.id}`}
        onChange={(event) => {
          let checkbox = document.getElementById('checkbox-' + item.id);
          if (checkbox.checked) {
            setQuantity(quantity === 0 ? 1 : quantity);
            checkboxHandler(item.value, quantity === 0 ? 1 : quantity)
          }
          else {
            setQuantity(0);
            checkboxHandler(item.value, 0, false)
          }
          
        }} 
        filledIn />
    </li>
  )
}

export default ServiceItem
